bovoApp.
factory('Station', ['$http', function($http) {
    return {
      all: function(type) {
        return $http.get('api/stations?type=' + type);
      },
      get: function(id) {
        return $http.get('api/station/' + id);
      },
      new: function(id) {
        return $http.get('api/new-station');
      },
      delete: function(id) {
        return $http.delete('api/delete-station/' + id);
      },
      save: function(data) {
        return $http.post('api/save-station',data);
      },
      update: function(data) {
        return $http.post('api/update-station',data);
      }
    };
}]);